import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './UpdateNotification.css';

/**
 * PWA update banner (execution dashboard only; mount point can be moved to App.js to show for all roles).
 * Listens for swUpdate; shows fixed bottom banner until user clicks reload or dismisses.
 */
export default function UpdateNotification() {
  const { t } = useTranslation('pwa');
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handler = (event) => setRegistration(event.detail);
    window.addEventListener('swUpdate', handler);
    return () => window.removeEventListener('swUpdate', handler);
  }, []);

  const handleReload = () => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  if (!registration?.waiting) return null;

  return (
    <div className="update-notification" role="status" aria-live="polite">
      <div className="update-notification-inner">
        <p className="update-notification-text">{t('updateAvailable')}</p>
        <button type="button" className="update-notification-btn" onClick={handleReload}>
          {t('reload')}
        </button>
      </div>
    </div>
  );
}
